module.exports = __webpack_public_path__ + "media/images/flags/32/Belarus-a61cb660df8aa65a6f1c10a3dbeb9afb.png";